<!-- Custom Confirmation modal -->
<div class="modal"  id="customConfirmation" tabindex="-1" role="dialog" aria-labelledby="Custom Confirmation" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body text-capitalize">
                {{ CustomMessage }} 
            </div>
            <div class="modal-footer" style="text-align:center !important;">                
                <a href="javascript:;" role="button" data-dismiss="modal" class="btn btn-sm btn-primary" >CANCEL</a>
                <a href="javascript:;" role="button" (click)="onSuccess(Id)" data-dismiss="modal" class="btn btn-sm btn-primary"  >OK</a>
            </div>
        </div>
    </div>
</div>
<!-- /Custom Confirmation modal -->